var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// elements/components/x-card.ts
import { html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { ChemistryLitElement } from "../../chemistry-lit-element";
import { css } from "../../directives/css";
import { elevation } from "../theming/design";
import "./x-flex";
import "./x-icon";
var ElementsCard = class extends ChemistryLitElement {
  constructor() {
    super(...arguments);
    this.popout = false;
    this.cardtitle = "";
  }
  styles() {
    return {
      ":host": {
        display: "block",
        boxSizing: "border-box",
        background: this.colors.white,
        padding: this.spacing.md,
        transition: "box-shadow .5s ease",
        borderRadius: this.sizes.borderRadius,
        boxShadow: elevation[2],
        width: "fit-content",
        "@media print": { boxShadow: "none", border: `1px solid ${this.colors.neutral_200}` }
      },
      ":host([no-elevation])": { boxShadow: "none" },
      ":host([popout]), :host([no-padding])": {
        padding: "0"
      },
      ...Object.fromEntries(
        Object.entries(this.colors.tone).map(([tone, color]) => [
          `:host([tone=${tone}])`,
          { background: color, color: this.colors.on.tone[tone] }
        ])
      )
    };
  }
  render() {
    if (this.popout)
      return html`
        <x-flex horizontal style="${{ width: "100%" }}">
          <x-flex
            center
            crossaxis-center
            padding="xs"
            ${css({
        background: this.colors.black,
        color: this.colors.on.black,
        marginRight: "1px",
        cursor: "pointer",
        userSelect: "none"
      })}
            @click="${() => this.dispatchEvent(new CustomEvent("close"))}"
          >
            <x-icon> close </x-icon>
          </x-flex>
          <x-flex
            horizontal
            flex
            crossaxis-center
            space-between
            space="md"
            padding="xs"
            ${css({ background: this.colors.black, color: this.colors.on.black })}
          >
            <x-h3> ${this.cardtitle} </x-h3>
            <slot name="after-title"></slot>
          </x-flex>
        </x-flex>
        <slot></slot>
      `;
    return html` <slot></slot> `;
  }
};
__decorateClass([
  property({ type: Boolean })
], ElementsCard.prototype, "popout", 2);
__decorateClass([
  property()
], ElementsCard.prototype, "cardtitle", 2);
ElementsCard = __decorateClass([
  customElement("x-card")
], ElementsCard);
export {
  ElementsCard
};
